import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/logo-background.webp")